import { render } from "./CabinetForm.vue?vue&type=template&id=68fc466b&scoped=true&ts=true"
import script from "./CabinetForm.ts?vue&type=script&lang=ts"
export * from "./CabinetForm.ts?vue&type=script&lang=ts"

import "./CabinetForm.scss?vue&type=style&index=0&id=68fc466b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fc466b"]])

export default __exports__